import service         from "@/services/HttpRequestService";
import ObjAlertState   from "@/components/common/alert/ObjAlertState";
import {TRACE_ERROR}   from "@/constants";
import ObjSpinnerState from "@/components/common/spinner/ObjSpinnerState";
import UtilsData       from "@/utilities/UtilsData";

export default class ManagerRequest {
  constructor(funcRequest, funcRequestContext = null, defaultReturn = null, flagSpinnerEnabled = true, flagAlertEnabled = true) {
    this.funcRequestContext  = funcRequestContext;
    this.funcRequest         = funcRequest;
    this.defaultReturn       = defaultReturn;
    this.toReturn            = this.defaultReturn;
    this.defaultErrorMessage = 'Unexpected REST-call error';
    this.response            = {};
    this.flagSpinnerEnabled  = flagSpinnerEnabled;
    this.flagAlertEnabled    = flagAlertEnabled;
    this.statusReport        = 'Created';
    this.errorMessage        = null;
    this.statusTagClass      = 'alert alert-info';
    return this;
  }

  async do() {
    try {
      if (this.flagSpinnerEnabled) {
        ObjSpinnerState.isOn = true;
      }
      this.statusReport = 'In-Progress';
      this.response = await this.funcRequest.apply(this.funcRequestContext, arguments);
      if (this.response.status >= 200 && this.response.status <= 299) {
        this.toReturn        = this.response.data;
        ObjSpinnerState.isOn = false;
        this.statusReport    = 'Done';
        this.statusTagClass  = 'alert alert-success';
        return this.toReturn;
      }
      this.statusReport = 'Failed';
      return this.defaultReturn;
    } catch (err) {
      this.statusReport = 'Failed';
      let errorMessage = this.defaultErrorMessage;
      if (err.message) {
        errorMessage = err.message;
      }
      if (
        err.response &&
        err.response.data
      ) {
        let data    = err.response.data;
        let resData = data;
        if (typeof resData === "string") {
          // Hidden, since response could contain server specific information.
          //errorMessage = resData;
          resData = UtilsData.tryAsJson(resData);
        }
        if (resData && resData.Message) {
          errorMessage = resData.Message;
        }
      }
      this.errorMessage   = errorMessage;
      this.statusTagClass = 'alert alert-danger';
      if (this.flagAlertEnabled) {
        ObjAlertState.set(`${errorMessage}`, 3);
      }
      await service.log(TRACE_ERROR, errorMessage, err.stack);
      return this.defaultReturn;
    } finally {
      ObjSpinnerState.isOn = false;
    }
  }
}
